import { Vehicle } from '@quorum/models/xs-resource';
import { VehicleQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export const GET_VEHICLES_FROM_SERVER = '[VEHICLE] Get Vehicles From Server';
export class GetVehiclesFromServer implements Action {
  readonly feature = 'vehicle';
  readonly type = GET_VEHICLES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: VehicleQueryParameters) {}
}

export const GET_VEHICLES_FROM_SERVER_SUCCESS = '[VEHICLE] Get Vehicles From Server Success';
export class GetVehiclesFromServerSuccess implements Action {
  readonly feature = 'vehicle';
  readonly type = GET_VEHICLES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { vehicles: Vehicle[] }) {}
}

export const GET_VEHICLES_FROM_SERVER_FAILURE = '[VEHICLE] Get Vehicles From Server Failure';
export class GetVehiclesFromServerFailure implements Action {
  readonly feature = 'vehicle';
  readonly type = GET_VEHICLES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type VehiclesAction = GetVehiclesFromServer | GetVehiclesFromServerSuccess | GetVehiclesFromServerFailure;
